<template>
  <div class="customerList">
    <!-- <van-cell
      title="选择日期"
      :value="date"
      @click="show = true"
      class="date-select"
      is-link
      arrow-direction="down"
    /> -->
    <van-list
      v-if="list && list.length"
      v-model="listLoading"
      :finished="finished"
      finished-text="没有更多了"
      @load="nextPage()"
    >
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <div class="row">
          <span class="key">保单号：</span>
          <span class="text">{{ item.policyNo }}</span>
        </div>
        <div class="row">
          <span class="key">保费：</span>
          <span class="text">{{ item.fee }}元</span>
        </div>
        <div class="row">
          <span class="key">佣金：</span>
          <span class="text">{{ item.commission }}元</span>
        </div>
        <div class="row">
          <span class="key">是否结算：</span>
          <span class="text">{{ item.js == '1' ? '是' : '否' }}</span>
        </div>
        <div class="row">
          <span class="key">是否提现：</span>
          <span class="text">{{ item.tx == '1' ? '是' : '否' }}</span>
        </div>
      </div>
    </van-list>
    <van-empty description="暂无内容" v-if="!list.length && !listLoading" />
    <van-calendar
      v-model="show"
      type="range"
      :show-confirm="false"
      color="#ff7553"
      :min-date="new Date(2021, 10, 1)"
      :max-date="new Date()"
      allow-same-day
      year-month
      @confirm="onConfirm"
    />
  </div>
</template>

<script>
import { pageTools } from "@/api/mixins";
export default {
  mixins: [pageTools],
  data() {
    return {
      date: "",
      show: false,
    };
  },
  computed: {},
  created() {
    this.initListAjax("/api/policysList");
  },
  methods: {
    setListParams(params) {
      params.searchValue = this.searchValue;
    },
    onConfirm(data) {
      this.show = false;
      const start = this.$tools.dateFormat(data[0], "yyyy-MM-dd");
      const end = this.$tools.dateFormat(data[1], "yyyy-MM-dd");
      if (start == end) {
        this.date = start;
      } else {
        this.date = `${start} - ${end}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.date-select {
  background-color: #f5f5f5;
  position: fixed;
  width: 100%;
  top: 0;
  .van-cell__value{
    flex: none;
  }
}
.van-list{
  // margin-top: 120px;
}
.list-item {
  background: #fff;
  border-radius: 10px;
  padding: 20px 30px;
  margin: 20px 30px 0;
  box-shadow: 0px 0px 20px #e7ecf6;
  .row {
    margin-bottom: 10px;
    font-size: 28px;
    font-family: PingFang SC;
    .key {
      color: #8a9095;
    }
    .text {
      color: #3c464f;
    }
  }
}
</style>
